export const routes = {
  default: "/",
  acquisition: "/acquisition",
  funnel: "/funnel",
  cohort: "/cohort",
};

export const routesDataMap: {
  [key: string]: string;
} = {
  [routes.default]: "Overview",
  [routes.acquisition]: "Acquisition & Activation",
  [routes.funnel]: "Funnel Analysis",
  [routes.cohort]: "Cohort Retention",
};
